import React from 'react'

const ResearchExamples = ( { handleClick }) => {
    const examples = [
        "トヨタとTeslaを比較して",
        "ソニーの有価証券報告書の要約して",
        "自動車業界を分析して",
        "ドラッグストアの動向をまとめて",
    ]
    return (
        <div className='flex flex-wrap gap-3 mt-4'>
            {examples.map((example) => (
                <div
                className="rounded-full py-2 px-5 flex items-center justify-center bg-green-100 hover:bg-green-200 shadow-lg cursor-pointer active:translate-x-1 active:translate-y-1 active:shadow-md transition-transform duration-100"
                onClick={() => handleClick(example)}
              >
                {example}
              </div>              
            ))}

        </div>
    )
}

export default ResearchExamples